module.exports = __webpack_public_path__ + "img/LY.c78c230d.svg";